<template>
  <div class="page-wrapper narrow-container">
    <div v-if="isMobile==false" class="container logo-container">
      <div class="row">
        <div class="col-12">
          <img src="@/assets/images/logo.gif" width="100%"/>
        </div>
      </div>
    </div>
    <div class="container  section-container">
      <h2>{{msg}} <span style="font-size: 15px;">v{{version}}</span></h2>
    </div>
    <div class="container">
      <div class="form-group row">
        <div class="col-12">
          <input type="text" id="userName" class="form-control text-center" placeholder="User Name" required
                 autocapitalize="none" @keyup.enter="login"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <input type="password" id="password" class="form-control text-center" placeholder="Password" required  @keyup.enter="login"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <div class="form-item">
            <input type="checkbox" class="form-check-input" id="autoLogin">
            <label class="form-check-label" for="autoLogin">로그인 상태유지</label>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <button type="button" class="form-control btn btn-primary" v-on:click="login(false)">로그인</button>
        </div>
        <div class="col-6" style="display:none;">
          <button type="button" class="form-control btn btn-secondary" v-on:click="moveToAdmin()">관리자</button>
        </div>
      </div>
    </div>
    <img src="@/assets/images/login_bg.png" width="100%"/>
    <v-dialog/>
  </div>
</template>
<script>
    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';
    import {getVersion} from "../api/Utils";

    export default {
        name: 'Login',
        data() {
            return {
              version:'',
                msg: '송장관리 시스템',
                isMobile: false,
            }
        },
        created: function () {
          this.$data.version = getVersion();
            this.$data.isMobile = isFromMobile();
        },
        methods: {
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            moveToAdmin: function () {
                Router.push('admin');
            },
            login: function () {
                var user_name = $("#userName").val();
                if (user_name.length == 0) {
                    console.log("no user name");
                    this.showModal("ERROR", "Enter User ID");
                    return;
                }
                var password = $("#password").val();

                if (password.length == 0) {
                    this.showModal("ERROR", "Enter Password");
                    return;
                }

                var self = this;
                axios.get(process.env.APP_URL + 'api/customer_login.php?user_name=' + user_name + '&password=' + password)
                    .then(response => {
                        console.log(response.data);
                        var data = response.data;
                        if (data['success'] == true) {
                            var userItem = data['user'];

                            console.log("successful login");
                            console.log(userItem);
                            localStorage.setItem('id', userItem['id']);
                            localStorage.setItem('email', userItem['email']);
                            localStorage.setItem('level', userItem['level']);
                            localStorage.setItem('account_type', userItem['type']);
                            localStorage.setItem('title', userItem['title']);
                            localStorage.setItem('code', userItem['code']);
                            localStorage.setItem('post_code', userItem['post_code']);
                            localStorage.setItem('address_1', userItem['address_1']);
                            localStorage.setItem('address_2', userItem['address_2']);
                            localStorage.setItem('contact_mobile', userItem['contact_mobile']);
                            localStorage.setItem('customer_printer', userItem['printer_url']);
                            Router.push('home');
                        } else {
                            self.showModal("LOGIN FAIL", data['message']);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        self.showModal("ERROR", error);
                    });


            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue